// UpdateBanner — "a new version is ready" pill, shown when a deploy lands while someone is using the app
// (main.jsx fires tmc:update-ready). Refresh reloads now; ✕ hides it for this session (main.jsx still reloads
// quietly the next time the app has sat in the background for a while).
import { useEffect, useState } from "react";

export default function UpdateBanner() {
  const [ready, setReady] = useState(() => !!window.__tmcUpdateReady);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("tmc.updateDismissed") === "1");
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("tmc:update-ready", on);
    return () => window.removeEventListener("tmc:update-ready", on);
  }, []);
  if (!ready || dismissed) return null;
  return (
    <div className="update-banner" role="status">
      <span>✨ A new version of TMC Chat is ready.</span>
      <button type="button" className="update-banner__go" onClick={() => window.location.reload()}>Refresh</button>
      <button type="button" className="update-banner__x" title="Later" onClick={() => { sessionStorage.setItem("tmc.updateDismissed", "1"); setDismissed(true); }}>✕</button>
    </div>
  );
}
